import React from 'react';
import classes from './style.module.scss';
import Footer from '../Footer/Footer';
import Entrance from '../../media/entrance.JPG';
import Whatsup from '../../media/whats.svg';
import Telegram from '../../media/telegram.svg';
import Instagram from '../../media/instagram.svg';
import VK from '../../media/vk_logo.svg';

const Contacts = () => {
    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className={classes.info}>
                    <div>
                        <div className={classes.infoText}>
                            <h2>Наши контакты</h2>
                            <p>
                                <span>
                                    Мы находимся по адресу г. Ногинск, ул.
                                    Комсомольская, дом 25.
                                </span>
                                <span>Время работы:</span>
                                <span>
                                    Понедельник - Воскресенье с 12:00 до 00:00
                                    или до последнего гостя.
                                </span>
                                <span>
                                    По любым вопросам вы можете связаться с нами
                                    по телефону или написать в сообщения группы
                                    в ВК
                                </span>
                                <span>Как с нами связаться</span>
                                <a href="tel:+79672775974">+7-967-277-59-74</a>
                                <div className={classes.social}>
                                    <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href="https://t.me/legendbogorodskiy"
                                    >
                                        <img src={Telegram} alt="telegram" />
                                    </a>
                                    <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href="https://chat.whatsapp.com/J30xu9VU7Xq4xpB50yAz0K"
                                    >
                                        <img src={Whatsup} alt="whatsup" />
                                    </a>
                                    <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href="https://vk.com/legendbogorodskiy"
                                    >
                                        <img src={VK} alt="vk" />
                                    </a>
                                    <a
                                        rel="noreferrer"
                                        target="_blank"
                                        href="https://instagram.com/legendbogorodskiy?igshid=MzRlODBiNWFlZA=="
                                    >
                                        <img src={Instagram} alt="instagram" />
                                    </a>
                                </div>
                                <span>
                                    Бронирование столов осуществляется только по
                                    телефону и в беседе в Whatsapp
                                </span>
                                <span>Ждём вас!</span>
                            </p>
                        </div>
                    </div>
                    <div className={classes.map}>
                        <a href="https://yandex.ru/maps/org/legenda/204861316326/?utm_medium=mapframe&utm_source=maps">
                            Легенда
                        </a>
                        <a href="https://yandex.ru/maps/10742/noginsk/category/billiard_hall/184106358/?utm_medium=mapframe&utm_source=maps">
                            Бильярдный клуб в Ногинске
                        </a>
                        <a href="https://yandex.ru/maps/10742/noginsk/category/bar_pub/184106384/?utm_medium=mapframe&utm_source=maps">
                            Бар, паб в Ногинске
                        </a>
                        <iframe
                            src="https://yandex.ru/map-widget/v1/?ll=38.447820%2C55.852491&mode=poi&poi%5Bpoint%5D=38.447534%2C55.852550&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D204861316326&z=19.09"
                            frameBorder="1"
                            allowFullScreen="true"
                        ></iframe>
                    </div>
                </div>
                <img className={classes.photo} src={Entrance} alt="entrance" />
            </div>
            <Footer />
        </div>
    );
};

export default Contacts;
